module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/ppa_presents-9ffdcda2ef138e90e14be483c614d6bd.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/ppa_presents.png
// module id = 2398
// module chunks = 2